import { render, staticRenderFns } from "./BlockMenuItem.vue?vue&type=template&id=057cce77&"
import script from "./BlockMenuItem.vue?vue&type=script&lang=js&"
export * from "./BlockMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports